// Which GLB each visitor kind renders with, keyed by entity.state.kind.
//
// null means no model: the viewer draws either the kind's bespoke
// procedural visual (KIND_VISUALS in components/three/world/Visitors.jsx,
// which wins over this file) or the standing placeholder. To give a
// future visitor a model instead, drop the file under public/models/ and
// put its path here, nothing else to touch.
//
// The octopus is deliberately not a model: it renders as shader-driven
// tentacles (OctopusTentacles.jsx) and ignores this table.
//
// Same footgun as the director props: a GLB with baked world transforms
// renders miles from the entity. Re-centre it at the origin in Blender
// first; position comes from the sim.

export const VISITOR_MODELS = {
  octopus: null,
}
